import { render, staticRenderFns } from "./CustomMontageMethods.vue?vue&type=template&id=a3c635ba&"
import script from "./CustomMontageMethods.vue?vue&type=script&lang=js&"
export * from "./CustomMontageMethods.vue?vue&type=script&lang=js&"
import style0 from "./CustomMontageMethods.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports